export type UsageMode = 'standalone' | 'hub' | 'solvie';

let usageMode: UsageMode = 'standalone';

export function setUsageMode(mode: UsageMode): void {
  usageMode = mode;
}

export function getUsageMode(): UsageMode {
  return usageMode;
}
